import {findValueRange} from "@reva/shared/number-format";

import {useSelectByCurrentLanguage} from "../../hooks/languageHooks";
import ParameterInputSelectButtons from "./ParameterInputSelectButtons";

/**
 * SelectButton input for parameters whose spec row defines value ranges (#18858), e.g. Lage,
 * Vermietbarkeit, Verwertbarkeit, Drittverwendungsfähigkeit, Beleihungsrisiko: instead of typing a
 * number, the user picks a range button, and its representativeValue is persisted.
 * @param {string} parameter parameter key
 * @param {RevaValueParameterType} parameterType type of parameter e.g. "AVM"
 * @param {string|null} [label] rendered label
 * @param {string} id ID of the input
 * @param {InputParameterDetailsDef|null} [parameter_details_def] optional parameter details definition
 * @param {RevaSpecObjectInputRange[]} ranges the ranges to render as buttons
 * @param {string|null} [associatedOutputParam] optional output parameter name, to highlight its range as a default
 * @param {number|null} [associatedOutputParamValue] optional default value to highlight directly, for callers whose suggestion doesn't come from an output parameter (e.g. location_flood_risk's climate-risk suggestion)
 * @param {string|null} [extraTooltipText] optional extra text appended to the label tooltip
 * @return {React.JSX.Element}
 */
export default function ParameterInputRangeButtons({
    parameter,
    parameterType,
    label,
    id,
    parameter_details_def,
    ranges,
    associatedOutputParam,
    associatedOutputParamValue,
    extraTooltipText,
}) {
    const selectByCurrentLanguage = useSelectByCurrentLanguage();

    const options = ranges.map((range) => ({
        value: range.representativeValue,
        label: selectByCurrentLanguage(range.nameDe, range.nameEn),
    }));

    return (
        <ParameterInputSelectButtons
            parameter={parameter}
            parameterType={parameterType}
            label={label}
            id={id}
            parameter_details_def={parameter_details_def}
            options={options}
            associatedOutputParam={associatedOutputParam}
            associatedOutputParamValue={associatedOutputParamValue}
            resolveOptionValue={(value) => findValueRange(ranges, value)?.representativeValue ?? null}
            extraTooltipText={extraTooltipText}
        />
    );
}
